<template>
  <!-- رتبه‌بندی تیمی مسابقات — آزاد و فرنگی کنار هم، تم سبز هماهنگ با اسلایدر اخبار -->
  <section v-if="hasData" class="team-standings" dir="rtl" aria-label="رتبه‌بندی تیمی مسابقات کشتی">
    <div class="standings-header">
      <h2 class="standings-title">
        <span class="standings-icon" aria-hidden="true">🏆</span>
        <span>رتبه‌بندی تیمی مسابقات</span>
        <span class="standings-sub">امتیاز کشورها بر پایهٔ نتایج رسمی UWW</span>
      </h2>
    </div>

    <div class="standings-panels">
      <!-- کشتی آزاد -->
      <div v-if="fsRows.length" class="standings-panel">
        <h3 class="panel-title fs">
          <span aria-hidden="true">🤼</span> کشتی آزاد
        </h3>
        <table class="standings-table">
          <thead>
            <tr>
              <th class="col-rank">#</th>
              <th class="col-team">کشور</th>
              <th class="col-pts">امتیاز</th>
            </tr>
          </thead>
          <tbody>
            <tr
                v-for="row in visibleRows(fsRows)"
                :key="'fs-' + row.code"
                :class="{ 'iran-row': row.code === 'IRI' }"
            >
              <td class="col-rank">{{ faRank(row.rank) }}</td>
              <td class="col-team">
                <img v-if="row.flagUrl" :src="row.flagUrl" :alt="row.nameFa || row.name" class="team-flag" loading="lazy">
                <span class="team-name">{{ row.nameFa || row.name }}</span>
                <span v-if="row.code === 'IRI'" class="iran-badge">ایران</span>
              </td>
              <td class="col-pts">{{ toFa(row.points) }}</td>
            </tr>
            <tr v-if="iranOutside(fsRows)" class="ellipsis-row">
              <td colspan="3">…</td>
            </tr>
            <tr
                v-if="iranOutside(fsRows)"
                class="iran-row iran-extended"
            >
              <td class="col-rank">{{ faRank(iranRow(fsRows).rank) }}</td>
              <td class="col-team">
                <img v-if="iranRow(fsRows).flagUrl" :src="iranRow(fsRows).flagUrl" alt="ایران" class="team-flag" loading="lazy">
                <span class="team-name">{{ iranRow(fsRows).nameFa || iranRow(fsRows).name }}</span>
                <span class="iran-badge">ایران</span>
              </td>
              <td class="col-pts">{{ toFa(iranRow(fsRows).points) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- کشتی فرنگی -->
      <div v-if="grRows.length" class="standings-panel">
        <h3 class="panel-title gr">
          <span aria-hidden="true">🤼‍♂️</span> کشتی فرنگی
        </h3>
        <table class="standings-table">
          <thead>
            <tr>
              <th class="col-rank">#</th>
              <th class="col-team">کشور</th>
              <th class="col-pts">امتیاز</th>
            </tr>
          </thead>
          <tbody>
            <tr
                v-for="row in visibleRows(grRows)"
                :key="'gr-' + row.code"
                :class="{ 'iran-row': row.code === 'IRI' }"
            >
              <td class="col-rank">{{ faRank(row.rank) }}</td>
              <td class="col-team">
                <img v-if="row.flagUrl" :src="row.flagUrl" :alt="row.nameFa || row.name" class="team-flag" loading="lazy">
                <span class="team-name">{{ row.nameFa || row.name }}</span>
                <span v-if="row.code === 'IRI'" class="iran-badge">ایران</span>
              </td>
              <td class="col-pts">{{ toFa(row.points) }}</td>
            </tr>
            <tr v-if="iranOutside(grRows)" class="ellipsis-row">
              <td colspan="3">…</td>
            </tr>
            <tr
                v-if="iranOutside(grRows)"
                class="iran-row iran-extended"
            >
              <td class="col-rank">{{ faRank(iranRow(grRows).rank) }}</td>
              <td class="col-team">
                <img v-if="iranRow(grRows).flagUrl" :src="iranRow(grRows).flagUrl" alt="ایران" class="team-flag" loading="lazy">
                <span class="team-name">{{ iranRow(grRows).nameFa || iranRow(grRows).name }}</span>
                <span class="iran-badge">ایران</span>
              </td>
              <td class="col-pts">{{ toFa(iranRow(grRows).points) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

const TOP_N = 10;

export default {
  name: 'WrestlingTeamStandings',
  data() {
    return {
      fsRows: [],
      grRows: [],
    };
  },
  computed: {
    hasData() {
      return this.fsRows.length > 0 || this.grRows.length > 0;
    },
  },
  async mounted() {
    await this.loadRankings();
  },
  methods: {
    async loadRankings() {
      try {
        const res = await api.request('/wrestling/team-rankings');
        const data = (res && res.data) || {};
        this.fsRows = Array.isArray(data.fs) ? data.fs : [];
        this.grRows = Array.isArray(data.gr) ? data.gr : [];
      } catch (e) {
        // بخش غیرحیاتی — در خطا مخفی می‌ماند
        this.fsRows = [];
        this.grRows = [];
      }
    },
    visibleRows(rows) {
      return rows.slice(0, TOP_N);
    },
    iranOutside(rows) {
      const iran = rows.find(r => r.code === 'IRI');
      return iran && iran.rank > TOP_N;
    },
    iranRow(rows) {
      return rows.find(r => r.code === 'IRI') || {};
    },
    faRank(rank) {
      if (rank === null || rank === undefined) return '—';
      return this.toFa(rank);
    },
    toFa(v) {
      return String(v ?? '').replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    },
  },
};
</script>

<style scoped lang="scss">
.team-standings {
  margin: 22px 0 0;
  padding: 16px 18px 18px;
  background: linear-gradient(135deg, #0e3b2e 0%, #14523f 70%, #1a6a50 100%);
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(14, 59, 46, 0.18);
}

.standings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.standings-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #fff;
  font-size: 17px;
  font-weight: 800;

  .standings-icon {
    font-size: 20px;
  }

  .standings-sub {
    font-size: 11.5px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.72);

    @media (max-width: 640px) {
      display: none;
    }
  }
}

.standings-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
}

.standings-panel {
  background: #fff;
  border-radius: 12px;
  padding: 12px 12px 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.14);
  overflow: hidden;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 10px;
  font-size: 14.5px;
  font-weight: 800;
  color: #163028;
  padding-bottom: 8px;
  border-bottom: 2px solid #e8efe9;

  &.fs {
    color: #14523f;
  }

  &.gr {
    color: #0e3b2e;
  }
}

.standings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;

  th {
    text-align: right;
    padding: 6px 8px;
    color: #6b7f77;
    font-size: 11px;
    font-weight: 700;
    border-bottom: 1px solid #eef3f0;
  }

  td {
    padding: 6.5px 8px;
    border-bottom: 1px solid #f2f6f4;
    color: #25382f;
  }

  tr:last-child td {
    border-bottom: none;
  }
}

.col-rank {
  width: 38px;
  font-weight: 800;
  color: #14523f !important;
}

.col-pts {
  width: 56px;
  text-align: left !important;
  font-weight: 800;
  color: #0e3b2e;
}

.col-team {
  display: flex;
  align-items: center;
  gap: 8px;
}

.team-flag {
  width: 26px;
  height: 18px;
  object-fit: cover;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.team-name {
  font-weight: 600;
}

.iran-badge {
  font-size: 9.5px;
  font-weight: 800;
  color: #fff;
  background: #1a6a50;
  border-radius: 100px;
  padding: 1px 7px;
}

/* ردیف ایران — هایلایت سبز */
tr.iran-row td {
  background: rgba(26, 106, 80, 0.09);
  font-weight: 800;
}

tr.iran-row td:first-child {
  border-right: 3px solid #1a6a50;
  border-radius: 4px 0 0 4px;
}

.ellipsis-row td {
  text-align: center;
  color: #94a39c;
  padding: 2px 8px;
}

@media (max-width: 640px) {
  .team-standings {
    padding: 12px 12px 14px;
    border-radius: 12px;
  }

  .standings-table {
    font-size: 12px;
  }
}
</style>
